import { showModal } from "../../../../../themes/custom/ev_theme/frontend/js/common/constants/functions/modalFunctions";
import { numberFormat } from "../../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { createDynamicSlider, initWhenReady } from "../../../../../themes/custom/ev_theme/frontend/js/components/sliders";
import { dataCalculator } from "../../../../../themes/custom/ev_theme/frontend/js/modules/form/setValueForm";
import { filterIndex, filterString } from "./results-load/results-query";
let countProject = 0;
const categories = {
    Bienestar: [29855, 27789, 29859, 27814, 27822, 27807, 27808, 27799, 29863, 27811, 27821, 27812, 27806],
    Deportivas: [29851, 27796, 27795, 27787, 27786, 27788, 27813, 27782, 27794],
    Infantiles: [27794, 27783],
    Trabajo: [27797],
    Entretenimiento: [29849, 27790, 29857, 7612, 29865, 27803, 29867, 27791, 27792, 27800]
};
const categoryTitles = {
    Bienestar: 'Zonas comunes de Bienestar',
    Deportivas: 'Zonas comunes Deportivas',
    Entretenimiento: 'Zonas comunes de Entretenimiento',
    Infantiles: 'Zonas comunes Infantiles',
    Trabajo: 'Zonas comunes de Trabajo'
};
/**
 * Closes the comparison and updates typology list
 */
export function closeCompare() {
    var _a;
    let typologyList = '';
    let compareList = Array.from(((_a = document.getElementById('content-projects-compare')) === null || _a === void 0 ? void 0 : _a.children) || []);
    const compareInputs = document.querySelectorAll('.ev-check-compare');
    compareInputs.forEach((input) => {
        const idTypology = input.id.split('_').pop();
        if (input.checked) {
            typologyList += `${idTypology}+`;
        }
    });
    if (typologyList || compareList.length > 1) {
        const comparatorSection = document.getElementById('comparatorSection');
        const hideComparatorButton = document.getElementById('hideComparatorButton');
        comparatorSection === null || comparatorSection === void 0 ? void 0 : comparatorSection.classList.remove('show-flex');
        hideComparatorButton === null || hideComparatorButton === void 0 ? void 0 : hideComparatorButton.classList.remove('d-none');
    }
}
;
function categorizeFeatures(features) {
    const grouped = {};
    for (const category in categories) {
        grouped[category] = features.filter(feature => categories[category].includes(Number(feature.id)));
    }
    return grouped;
}
/**
 * Shows the comparator section
 */
export function showComparatorSection() {
    const comparatorSection = document.getElementById('comparatorSection');
    const hideComparatorButton = document.getElementById('hideComparatorButton');
    comparatorSection === null || comparatorSection === void 0 ? void 0 : comparatorSection.classList.add('show-flex');
    hideComparatorButton === null || hideComparatorButton === void 0 ? void 0 : hideComparatorButton.classList.add('d-none');
}
;
/**
 * Extracts percentage from a string
 * @param percentage The percentage string (e.g., "20%")
 * @returns The numeric value as a string
 */
function getPercentageNumber(percentage) {
    const percentageValue = percentage.split("%");
    const numberValue = percentageValue.filter(value => value !== "");
    return numberValue.length < 1 || numberValue[0] === "" ? 0 : parseFloat(numberValue[0]);
}
/**
 * Calculates the down payment based on percentage and price
 * @param percentage The down payment percentage
 * @param fullPrice The full price of the item
 * @returns The formatted down payment
 */
function calculateDownPayment(percentage, fullPrice) {
    const percentageValue = getPercentageNumber(percentage);
    const downPaymentValue = Number((percentageValue * Number(fullPrice)) / 100);
    return numberFormat(downPaymentValue);
}
/**
 * Adds a project to the comparison section.
 *
 * This function generates and appends a comparison card for a project to the comparison section,
 * displaying details such as location, price, project features, and financing options.
 *
 * @param {Object} typology - The object containing project information to compare.
 * @param {string} customClass - The custom CSS class to add to the comparison card.
 */
function applyCompare(typology, customClass) {
    // Get project features and convert them to an array if they exist
    var _a;
    let ids = typology.project_feature.split(',').map(s => s.trim());
    let labels = (_a = typology.project_features_raw_list) === null || _a === void 0 ? void 0 : _a.split(',').map(s => s.trim());
    let typologyFeaturesList = ids.map((id, i) => ({
        id,
        label: labels ? labels[i] : ''
    }));
    const groupedFeatures = categorizeFeatures(typologyFeaturesList);
    const typologyHasNoFeatures = Object.values(groupedFeatures).every(arr => arr.length === 0);
    let accordionHtml = "";
    if (typologyHasNoFeatures) {
        accordionHtml = `<p class="card-compare__feature-item__text mh">No hay zonas comunes disponibles.</p>`;
    }
    else {
        accordionHtml = Object.entries(groupedFeatures)
            .filter(([_, features]) => features.length > 0)
            .map(([category, features], index) => {
            const customTitle = categoryTitles[category] || category;
            return `
                  <div class="ev-accordion__item">
                    <h2 class="ev-accordion__header" id="heading${index}-${typology.nid}">
                      <button class="ev-accordion__button accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse${index}-${typology.nid}" aria-expanded="false" aria-controls="collapse${index}-${typology.nid}">
                        <span class="card-compare__feature-category">${customTitle} <b>(${features.length})</b></span>
                      </button>
                    </h2>
                    <div id="collapse${index}-${typology.nid}" class="collapse" aria-labelledby="heading${index}-${typology.nid}" data-bs-parent="#featuresAccordion">
                      <div class="ev-accordion__body">
                        ${features.map(f => `<p class="card-compare__feature-name">${f.label}</p>`).join('')}
                      </div>
                    </div>
                  </div>
                `;
        }).join('');
    }
    const paramsWhiteBrand = new URLSearchParams(window.location.search);
    const existsWhiteBrand = paramsWhiteBrand.get('product') == 'fair-white-brand';
    const whiteBrand = window.location.pathname.includes('/feria-propia/') || existsWhiteBrand;
    const urlLQN = whiteBrand ? '/preaprobacion-en-linea-feria-propia' : '/preaprobacion-en-linea';
    // Create the HTML for the comparison card
    const cardHtml = `
        <li style="display: none;" class="splide__slide ${customClass} js-compare-slide" id="card-compare-position-${typology.nid}">
            <div class="card-compare">
                <a target="_blank" href="/node/${typology.nid}" class="link link--under">Ir al proyecto &#10095;</a>

                <div class="card-compare__header">
                    <a target="_blank" href="/node/${typology.nid}" class="card-compare__header__title">${typology.proyecto}</a>
                    <button id="close-card-compare-${typology.nid}" class="tone-btn grey">
                        <img src="/themes/custom/ev_theme/assets/images/fontawesome/trash-solid.svg" alt="Quitar card">
                    </button>
                </div>

                <p class="card-compare__builder">
                    Un proyecto de <strong>${typology.builder_name.length > 32 ? typology.builder_name.slice(0, 32) + '...' : typology.builder_name}</strong>
                </p>

                <div class="card-compare__images">
                    <a target="_blank" href="/node/${typology.nid}">
                        <img alt="Imagen del inmueble" src="${typology.project_img}" class="card-compare__images__project">
                    </a>
                    <img alt="Un proyecto de ${typology.builder_name}" title="Un proyecto de ${typology.builder_name}" src="${typology.builder_logo}" class="card-compare__images__builder">
                </div>

                <div class="card-compare__fw-item">
                    <label class="card-compare__fw-item__label">Ubicación:</label>
                    <p class="card-compare__fw-item__text">${typology.city} - ${typology.sector}</p>
                </div>
                <div class="card-compare__fw-item">
                    <label class="card-compare__fw-item__label">Tipo de Inmueble</label>
                    <p class="card-compare__fw-item__text">${typology.property_type}</p>
                </div>

                <div class="card-compare__item">
                    <p class="card-compare__item__title">Precio</p>
                    <p class="card-compare__item__text"><span class="card-compare__item__text__label">Desde: </span><strong>$ ${numberFormat(typology.precio)}</strong></p>
                </div>

                 ${typology.present_value ? `
                    <div class="card-compare__feature typology-features ev-tooltip area-simulation">
                        <div class="card-compare__feature-item card-compare__feature-item--fw">
                            <div class="card-compare__feature-item__title ev-tooltip__container">Valor presente neto
                                <div class="ev-tooltip__label"> ? </div>
                                <div class="ev-tooltip__info">Valor actual del costo total de tu vivienda</div>
                             </div>
                            <p class="card-compare__feature-item__text">${typology.present_value === '' ? 'Información no disponible' : '$' + numberFormat(typology.present_value)}</p>
                        </div>
                    </div>
                ` : ''}

                <div class="card-compare__feature typology-features">
                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Área</p>
                        <p class="card-compare__feature-item__text">${typology.area} m<sup>2</sup></p>
                    </div>
                    ${typology.alcobas ? `
                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Alcobas</p>
                        <p class="card-compare__feature-item__text">${typology.alcobas}</p>
                    </div>` : ''}
                    ${typology.banos ? `
                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Baños</p>
                        <p class="card-compare__feature-item__text">${typology.banos}</p>
                    </div> ` : ''}
                    ${typology.garaje ? `
                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Garaje</p>
                        <p class="card-compare__feature-item__text">${typology.garaje}</p>
                    </div>` : ''}

                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Estrato</p>
                        <p class="card-compare__feature-item__text">${typology.estrato ? typology.estrato : 'No disponible'}</p>
                    </div>
                    ${typology.finishes ? `
                    <div class="card-compare__feature-item">
                        <p class="card-compare__feature-item__title">Acabados</p>
                        <p class="card-compare__feature-item__text">${typology.finishes}</p>
                    </div>` : ''}
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__feature-item__title">Relación parqueaderos</p>
                        <p class="card-compare__feature-item__text">${typology.field_relaci_n_de_parqueaderos === '' ? 'Información no disponible' : typology.field_relaci_n_de_parqueaderos} </p>
                    </div>
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__feature-item__title">Año de entrega (Aprox.)</p>
                        <p class="card-compare__feature-item__text">${typology.fecha_de_entrega_anio === '' ? 'Información no disponible' : typology.fecha_de_entrega_anio}</p>
                    </div>
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__feature-item__title">Meses para la entrega</p>
                        <p class="card-compare__feature-item__text">${typology.meses_para_entrega === '' ? 'Información no disponible' : typology.meses_para_entrega}</p>
                    </div>
                </div>

                <div class="card-compare__feature project-features">
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__feature-item__title">Total de unidades</p>
                        <p class="card-compare__feature-item__text">${typology.total_project_units === '' ? 'Información no disponible' : typology.total_project_units}</p>
                    </div>
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__feature-item__title">Zonas comunes disponibles</p>
                        ${!typologyHasNoFeatures ? `<div class="accordion mt-2 ev-accordion">${accordionHtml}</div>`
        : `<p class="card-compare__feature-item__text mh">No hay zonas comunes disponibles</p>`}
                    </div>
                </div>

                ${typology.property_type !== 'Lote' ? `
                <div class="card-compare__feature financial-features">
                    <h3 class="card-compare__feature__title">Financiamiento</h3>
                    <div class="card-compare__item">
                        <p class="card-compare__item__title">Precio desde</p>
                        <p class="card-compare__item__text"><strong>$ ${numberFormat(typology.precio)}</strong></p>
                    </div>
                    <div class="card-compare__item card-compare__item">
                        <p class="card-compare__item__title">Precio por m<sup>2</sup></p>
                        <p class="card-compare__item__text"><strong>$ ${numberFormat(Math.floor(Number(typology.precio) / Number(typology.area)))}</strong></p>
                    </div>
                    <div class="card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__item__title">Cuota Inicial</p>
                        <p class="card-compare__item__text"><strong>${getPercentageNumber(typology.field_down_payment)} % - $ ${calculateDownPayment(typology.field_down_payment, typology.precio)}</strong></p>
                    </div>
                    <div class="card-compare__item card-compare__item--last card-compare__feature-item card-compare__feature-item--fw">
                        <p class="card-compare__item__title">Cuota aprox. (20 años)</p>
                        <p class="card-compare__item__text"><strong>${dataCalculator.calculateQuote(Number(typology.precio), Number(typology.tipo_vivienda), 30, 20)}</strong></p>
                    </div>
                </div>
                <a class="fc-filled-btn self-center" href="${urlLQN}" target="_blank">
                    Quiero gestionar mi crédito
                </a>` : ''}
            </div>
        </li>
    `;
    const compareSection = document.getElementById('compare-section');
    if (compareSection) {
        compareSection.insertAdjacentHTML('beforeend', cardHtml);
    }
}
/**
 * Loads the comparison cards based on selected typologies.
 *
 * This function retrieves selected typologies from the DOM, fetches their data from the server,
 * and displays them in a comparison section. It also handles adding event listeners for
 * removing items from the comparison.
 */
export function loadCompare() {
    document
        .querySelectorAll('.js-compare-slide')
        .forEach(card => card.remove());
    const compareCardElements = document.querySelectorAll('.compare-card');
    const typologyList = Array.from(compareCardElements)
        .map(card => card.id.replace('compare-', ''))
        .join('+');
    const filters = filterString();
    let filter = filterIndex(filters);
    let url = '';
    if (filter.includes('datapro')) {
        url = `/api/v1/comparator-unpublish?node_id=${typologyList}`;
    }
    else {
        url = `/api/v1/comparator?node_id=${typologyList}`;
    }
    fetch(url)
        .then(response => response.json())
        .then((data) => {
        var _a, _b, _c;
        Object.entries(data).forEach(([_, typology]) => {
            const setResponsiveClass = `card-compare-position-${typology.nid}`;
            applyCompare(typology, setResponsiveClass);
            const compareCard = document.getElementsByClassName(setResponsiveClass)[0];
            compareCard.style.display = 'flex';
            const closeButton = document.getElementById(`close-card-compare-${typology.nid}`);
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', () => handleCardRemoval(typology.nid, false));
        });
        (_a = document.getElementById('comparatorContent')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
        (_b = document.getElementById('sliderContent')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
        (_c = document.getElementById('sliderContent')) === null || _c === void 0 ? void 0 : _c.classList.add('d-block');
        const slider = document.getElementById('slider-compare');
        initWhenReady(() => {
            const slider = document.getElementById('slider-compare');
            if (!slider)
                return;
            if (window.innerWidth < 1000) {
                createDynamicSlider(slider, {
                    perPage: 1,
                    speed: 500,
                    rewind: true,
                    rewindSpeed: 500,
                    dragMinThreshold: {
                        mouse: 30,
                        touch: 40,
                    },
                });
            }
            else {
                createDynamicSlider(slider, {
                    perPage: 4,
                    arrows: false,
                    pagination: false,
                });
            }
        });
    });
}
/**
 * Displays the summary of the comparison cards.
 *
 * This function switches the view from the slider to the comparator content and enables
 * the display of the summary for comparison.
 */
export function seeSummaryCards() {
    var _a, _b, _c;
    (_a = document.getElementById('sliderContent')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-block');
    (_b = document.getElementById('comparatorContent')) === null || _b === void 0 ? void 0 : _b.classList.add('d-flex');
    (_c = document.getElementById('comparatorContent')) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
}
/**
 * Adds a project to the comparison section based on its ID.
 *
 * This function checks whether a project is selected for comparison and then adds it to the
 * comparison list, displaying relevant project details such as title, type, and price.
 *
 * @param {number} id - The ID of the typology/project to add.
 */
export function addItemToCompare(id) {
    var _a, _b;
    const itemCheckbox = document.getElementById(`comparador_${id}`);
    const openCompare = document.querySelector('.open-compare');
    if ((itemCheckbox === null || itemCheckbox === void 0 ? void 0 : itemCheckbox.checked) && !document.getElementById(`compare-${id}`)) {
        if (countProject < 4) {
            countProject++;
            addCompareCard(id);
            updateHints();
        }
        else {
            showModal('message-compare');
            itemCheckbox.checked = false;
        }
    }
    else {
        --countProject;
        (_a = document.getElementById(`compare-${id}`)) === null || _a === void 0 ? void 0 : _a.remove();
        const cardComparePostion = document.getElementsByClassName(`card-compare-position-${id}`)[0];
        if (cardComparePostion) {
            cardComparePostion.style.display = "none";
        }
        if (itemCheckbox) {
            itemCheckbox.checked = false;
        }
        countProject = Math.max(0, countProject);
        if (!document.querySelector('.compare-section') && countProject == 0) {
            (_b = document.querySelector('.comparator')) === null || _b === void 0 ? void 0 : _b.classList.remove('show-flex');
            openCompare === null || openCompare === void 0 ? void 0 : openCompare.classList.add('d-none');
        }
        updateHints();
    }
    toggleCompareButton();
    const deleteCardButton = document.getElementById(`delete-card-compare-${id}`);
    deleteCardButton === null || deleteCardButton === void 0 ? void 0 : deleteCardButton.addEventListener('click', () => handleCardRemoval(id, true));
}
/**
 * Unchecks all selected typologies and removes their comparison cards.
 *
 * This function unchecks all compare checkboxes and removes their associated
 * comparison cards from the DOM, resetting the comparison section.
 */
export function uncheckAll() {
    var _a;
    const compareInputs = document.querySelectorAll('.ev-check-compare');
    compareInputs.forEach((input) => {
        const idTypology = input.id.split('_').pop();
        if (input.checked) {
            input.checked = false;
            if (idTypology) {
                addItemToCompare(idTypology);
            }
        }
    });
    const compareCards = document.querySelectorAll('.compare-card');
    compareCards.forEach((card) => {
        const idTypology = card.id.replace('compare-', '');
        addItemToCompare(idTypology);
    });
    (_a = document.getElementById('hint')) === null || _a === void 0 ? void 0 : _a.remove();
    // Hide the comparator section and hide the comparator button
    const comparatorSection = document.getElementById('comparatorSection');
    const hideComparatorButton = document.getElementById('hideComparatorButton');
    comparatorSection === null || comparatorSection === void 0 ? void 0 : comparatorSection.classList.remove('show-flex');
    hideComparatorButton === null || hideComparatorButton === void 0 ? void 0 : hideComparatorButton.classList.add('d-none');
}
function updateHints() {
    const contentProjectsCompare = document.getElementById('content-projects-compare');
    document.querySelectorAll('.compare-card--hint').forEach(hint => hint.remove());
    let countHint = 0;
    if (countProject === 0) {
        countHint = 2;
    }
    else if (countProject === 1) {
        countHint = 1;
    }
    for (let i = 0; i < countHint; i++) {
        contentProjectsCompare === null || contentProjectsCompare === void 0 ? void 0 : contentProjectsCompare.insertAdjacentHTML('beforeend', `
                <div class="compare-card compare-card--hint" id="hint">
                    <div class="compare-card__content">
                        <div class="compare-card__header">
                            <p class="compare-card__header__title">Debes seleccionar al menos dos inmuebles para iniciar la comparación</p>
                        </div>
                    </div>
                </div>
            `);
    }
}
function addCompareCard(id) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const imgLink = (_a = document.querySelector(`#result-${id} #splide${id} img`)) === null || _a === void 0 ? void 0 : _a.src;
    const title = (_b = document.querySelector(`#result-${id} .js_title_add_item_compare`)) === null || _b === void 0 ? void 0 : _b.textContent;
    const typeProject = (_c = document.querySelector(`#result-${id} .js_location_add_item_compare`)) === null || _c === void 0 ? void 0 : _c.textContent;
    let priceProject = ((_d = document.querySelector(`#result-${id} .js_price_add_item_compare`)) === null || _d === void 0 ? void 0 : _d.textContent) || '';
    priceProject = priceProject.replace(/\s/g, '');
    const safeTypeProject = typeProject !== null && typeProject !== void 0 ? typeProject : '';
    const isMobile = window.innerWidth < 768;
    const contentProjectsCompare = document.getElementById('content-projects-compare');
    contentProjectsCompare === null || contentProjectsCompare === void 0 ? void 0 : contentProjectsCompare.insertAdjacentHTML('beforeend', `
            <div class="compare-card" id='compare-${id}'>
                <div class='compare-card__img' style='background-image:url("${imgLink}");'></div>
                <div class='compare-card__content'>
                    <div class='compare-card__header'>
                        <p class='compare-card__header__title'>${title}</p>
                        <button id="delete-card-compare-${id}" class="tone-btn grey">
                            <img src="/themes/custom/ev_theme/assets/images/fontawesome/trash-solid.svg">
                        </button>
                    </div>
                    <div class='compare-card__body'>
                        <div class='compare-card__body__location'>
                            ${safeTypeProject.length > 35 && isMobile
        ? `<div id="minus-text-comparador-${id}">` + safeTypeProject.substring(0, 35) + `... <span id="text-comparador-${id}" class="btn-more-text link link--under">Leer más</span> </div>`
        : safeTypeProject}
                            <div class="all-text" id="more-text-comparador-${id}" style="display:none;">
                                ${safeTypeProject}
                                <span id="text-comparador-${id}" ="btn-more-text link link--under">Leer menos</span>
                            </div>
                        </div>
                        <p class='compare-card__body__price'>
                            <span class='compare-card__body__price__label'>Desde: </span>${priceProject}
                        </p>
                    </div>
                </div>
            </div>`);
    updateHints();
    const comparePosition = document.getElementsByClassName(`card-compare-position-${id}`)[0];
    if (comparePosition) {
        comparePosition.style.display = 'block';
    }
    (_e = document.querySelector('.comparator')) === null || _e === void 0 ? void 0 : _e.classList.add('show-flex');
    (_f = document.getElementById('sliderContent')) === null || _f === void 0 ? void 0 : _f.classList.add('d-none');
    (_g = document.getElementById('comparatorContent')) === null || _g === void 0 ? void 0 : _g.classList.remove('d-none');
    (_h = document.getElementById('comparatorSection')) === null || _h === void 0 ? void 0 : _h.classList.add('show-flex');
    (_j = document.getElementById('hideComparatorButton')) === null || _j === void 0 ? void 0 : _j.classList.add('d-none');
    const btns = Array.from(document.getElementsByClassName('btn-more-text'));
    btns.forEach(btn => btn.addEventListener('click', openTextComparator));
}
// Enable or disable the compare button based on the number of projects selected
function toggleCompareButton() {
    const IdButtonCompare = screen.width > 1000 ? 'compareButton' : 'compareButtonMobile';
    const compareButton = document.getElementById(IdButtonCompare);
    if (countProject > 1) {
        compareButton === null || compareButton === void 0 ? void 0 : compareButton.classList.remove('disabled');
    }
    else {
        compareButton === null || compareButton === void 0 ? void 0 : compareButton.classList.add('disabled');
    }
}
function handleCardRemoval(nid, isDelete) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const cardToRemove = document.getElementsByClassName(`card-compare-position-${nid}`)[0];
    const compareCardToRemove = document.getElementById(`compare-${nid}`);
    const itemToUncheck = document.getElementById(`comparador_${nid}`);
    cardToRemove === null || cardToRemove === void 0 ? void 0 : cardToRemove.remove();
    compareCardToRemove === null || compareCardToRemove === void 0 ? void 0 : compareCardToRemove.remove();
    if (itemToUncheck)
        itemToUncheck.checked = false;
    countProject--;
    if (countProject === 1) {
        (_a = document.getElementById('sliderContent')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-block');
        (_b = document.getElementById('comparatorContent')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
        const IdButtonCompare = screen.width > 1000 ? 'compareButton' : 'compareButtonMobile';
        (_c = document.getElementById(IdButtonCompare)) === null || _c === void 0 ? void 0 : _c.classList.add('disabled');
    }
    // else if (screen.width < 1000 && isDelete == false) {
    //     comparatorSplide.refresh();
    // }
    if (isDelete) {
        if (countProject === 1) {
            const hint = document.createElement('div');
            hint.id = 'hint';
            hint.classList.add('compare-card', 'compare-card--hint');
            hint.innerHTML = `
                <div class='compare-card__content'>
                    <div class='compare-card__header'>
                        <p class='compare-card__header__title'>Debes seleccionar al menos dos inmuebles para iniciar la comparación</p>
                    </div>
                </div>`;
            (_d = document.getElementById('content-projects-compare')) === null || _d === void 0 ? void 0 : _d.appendChild(hint);
            const IdButtonCompare = screen.width > 1000 ? 'compareButton' : 'compareButtonMobile';
            (_e = document.getElementById(IdButtonCompare)) === null || _e === void 0 ? void 0 : _e.classList.add('disabled');
        }
        else if (countProject === 0) {
            (_f = document.getElementById('comparatorSection')) === null || _f === void 0 ? void 0 : _f.classList.remove('show-flex');
            (_h = (_g = document.getElementById('content-projects-compare')) === null || _g === void 0 ? void 0 : _g.querySelector('#hint')) === null || _h === void 0 ? void 0 : _h.remove();
        }
    }
    countProject = Math.max(0, countProject);
}
function loadDefaultComparative() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const nid = urlParams.get('nid');
    if (nid) {
        // Splite
        const nids = nid.trim().split(/\s+/);
        // Go into if there is one nid
        if (nids.length === 1) {
            const id = nids[0];
            const checkbox = document.getElementById(`comparador_${id}`);
            if (checkbox) {
                checkbox.checked = true;
                addItemToCompare(id);
            }
        }
    }
}
function openTextComparator(e) {
    let btn = document.getElementById(e.srcElement.id);
    const text = document.getElementById("more-" + e.srcElement.id);
    const minusText = document.getElementById("minus-" + e.srcElement.id);
    text === null || text === void 0 ? void 0 : text.classList.toggle("more-text-open");
    (text === null || text === void 0 ? void 0 : text.classList.contains("more-text-open")) ? btn.innerHTML = "Leer menos" : btn.innerHTML = "Leer más";
    text.style.display = (text === null || text === void 0 ? void 0 : text.classList.contains("more-text-open")) ? 'block' : 'none';
    minusText.style.display = !(text === null || text === void 0 ? void 0 : text.classList.contains("more-text-open")) ? 'block' : 'none';
}
document.addEventListener('DOMContentLoaded', function () {
    loadDefaultComparative();
});
